<script setup lang="ts">
import type { PropertySeoLinkItem } from '@@/shared/property/seo-link';

const props = defineProps<{
  item: PropertySeoLinkItem
  displayAll: boolean
  index: number
}>();

const link = computed(() => {
  return {
    to: {
      name: 'serp-serpSlug',
      params: { serpSlug: props.item.serpSlug },
    },
  };
});
const { linkComponent, linkBindings } = useLinksBuilder(link);

const { t } = useI18n();
const text = computed(() => {
  if (typeof props.item.text === 'string') return props.item.text;
  if (props.item.text[1]) return t(props.item.text[0], props.item.text[1]);
  return t(props.item.text[0]);
});

const visuallyHidden = computed(() => {
  if (props.displayAll) return false;
  return props.index > 5;
});
</script>

<template>
  <li :class="{ 'sr-only': visuallyHidden }">
    <component
      :is="linkComponent"
      v-bind="linkBindings"
      class="text-sm hover:underline"
    >
      {{ text }}
    </component>
  </li>
</template>
